import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 71,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 bg-navy-dark text-white px-4 border-t border-white/10" data-id="element-107">
      <div className="max-w-4xl mx-auto text-center" data-id="element-108">
        <div className="inline-block bg-white/10 text-white font-medium px-4 py-1 rounded-full text-sm mb-6" data-id="element-109">
          No dejes pasar esta oportunidad
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-110">
          El precio de lanzamiento no dura para siempre
        </h2>

        <p className="text-lg text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-111">
          Todo lo que necesitás para que tus redes empiecen a traerte
          compradores reales, en un solo pack. Descargás hoy, aplicás hoy.
        </p>

        <div className="flex justify-center gap-4 mb-10" data-id="element-112">
          <div className="flex flex-col items-center" data-id="element-113">
            <div className="text-3xl font-bold text-sky" data-id="element-114">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <span className="text-slate-400 text-xs uppercase" data-id="element-115">Horas</span>
          </div>
          <div className="text-3xl font-bold text-sky" data-id="element-116">:</div>
          <div className="flex flex-col items-center" data-id="element-117">
            <div className="text-3xl font-bold text-sky" data-id="element-118">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <span className="text-slate-400 text-xs uppercase" data-id="element-119">Minutos</span>
          </div>
          <div className="text-3xl font-bold text-sky" data-id="element-120">:</div>
          <div className="flex flex-col items-center" data-id="element-121">
            <div className="text-3xl font-bold text-sky" data-id="element-122">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <span className="text-slate-400 text-xs uppercase" data-id="element-123">Segundos</span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-124">
          <a href="https://checkout.saberclick.com/products/megapack-publicidad-en-redes-sociales?variant=50294409199809" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-sky hover:bg-sky-hover text-navy font-bold text-lg px-10 py-5 rounded-xl transition-all shadow-[0_0_20px_rgba(56,189,248,0.4)] hover:scale-105" data-id="element-125">
            💥 SÍ, QUIERO EL MEGAPACK AHORA
          </a>

          <a href="https://checkout.saberclick.com/products/pack-publicidad-en-redes-sociales?variant=50294396780737" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white underline transition-colors" data-id="element-126">
            Quiero solo el Pack Esencial ($19.990)
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mt-12 text-sm font-medium text-slate-400" data-id="element-127">
          <div className="flex items-center gap-2" data-id="element-128">
            <Lock className="w-4 h-4" data-id="element-129" />
            <span data-id="element-130">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-131">
            <Zap className="w-4 h-4" data-id="element-132" />
            <span data-id="element-133">Acceso en minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-134">
            <ShieldCheck className="w-4 h-4" data-id="element-135" />
            <span data-id="element-136">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}